{
  "backButton": "Вернуться к {prevMenuButton}",
  "moreActions": "Дополнительные действия",
  "unavailable": "Недоступно, разверните для подробностей"
}
